module.exports = __webpack_public_path__ + "img/191.missing_toiletries.3baf28aa.svg";